import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords = 'wandelcoaching, coaching, wandelcoach, natuurcoaching, persoonlijke ontwikkeling, stressmanagement, burn-out coaching, balans, energie, Nederland, CtheNature',
  image = '/ChantalBerg.jpg',
  url,
  type = 'website'
}) => {
  const siteUrl = 'https://cthenature.com'; 
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="CtheNature" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:site_name" content="CtheNature - Wandelcoaching" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Additional SEO Tags */}
      <meta name="language" content="Dutch" />
      <meta name="geo.region" content="NL" />
      <meta name="geo.placename" content="Deursen-Dennenburg, Ravenstein" />
      
      {/* Structured Data - LocalBusiness */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "CtheNature",
          "description": description,
          "url": siteUrl,
          "logo": `${siteUrl}/Logo_met_Vlinder.png`,
          "image": imageUrl,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Deursen-Dennenburg",
            "addressRegion": "Ravenstein",
            "addressCountry": "NL"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "addressLocality": "Deursen-Dennenburg"
          },
          "email": "cthenature@outlook.com",
          "priceRange": "€€",
          "areaServed": {
            "@type": "Country",
            "name": "Nederland"
          },
          "serviceType": "Wandelcoaching",
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Wandelcoaching Diensten",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Kennismakingsgesprek",
                  "description": "Gratis kennismakingsgesprek van 30 minuten"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Kickstart traject",
                  "description": "Kort en krachtig wandelcoaching traject van 3 sessies"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Duurzaam traject",
                  "description": "Diepgaand wandelcoaching traject van 6 weken"
                }
              }
            ]
          }
        })}
      </script>

      {/* Structured Data - Service */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "serviceType": "Wandelcoaching",
          "provider": {
            "@type": "Person",
            "name": "Chantal",
            "jobTitle": "Wandelcoach"
          },
          "areaServed": {
            "@type": "Country",
            "name": "Nederland"
          },
          "description": "Professionele wandelcoaching in de natuur voor persoonlijke ontwikkeling, stressmanagement en balans"
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
